import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, concatMap } from 'rxjs/operators';
import * as subjectsActions from '../action/units-statistics-subject.actions';
import { AdministratorStatisticsService } from '../../../../../../services/administrator-statistics.service';

@Injectable()
export class UnitsStatisticsSubjects {
   constructor(
      private actions$: Actions,
      private administratorStatistics: AdministratorStatisticsService
   ) {}

   /**
    * Effect listening for subjectsStatistics Action, when subjectsStatistics is dispatched the effect with call create() from courseService.
    * In case of success response the effect it will trigger subjectsStatisticsSuccess.
    * In case of Error it will trigger subjectsStatisticsFailure with error property.
    */
   subjectsStatistics$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(subjectsActions.loadUnitsStatisticsSubjects),
         concatMap((action) => {
            return this.administratorStatistics
               .academicUnitsSubjectsStatistics(
                  action.page,
                  action.title,
                  action.faculty,
                  action.department,
                  action.professor,
                  action.studentName
               )
               .pipe(
                  map((data) => {
                     return subjectsActions.loadUnitsStatisticsSubjectsSuccess({
                        data: data,
                     });
                  }),
                  catchError((error) =>
                     of(
                        subjectsActions.loadUnitsStatisticsSubjectsFailure({
                           error,
                        })
                     )
                  )
               );
         })
      );
   });
}
